export function getOrganizationOrderCreationDtoJson(json) {

    let organizationOrderCreationDto = JSON.parse(json);

    return getOrganizationOrderCreationDto(organizationOrderCreationDto);

}
export function getOrganizationOrderCreationDto(organizationOrderCreationDto) {

    let func = function (address) {
        address.getAddress = function () {

                return this.address +
                (this.houseNo != null && this.houseNo != "" ? " " + this.houseNo : "")
                + (this.city != null && this.city != "" ? " " + this.city : "")
                + (this.province != null && this.province != "" ? " " + this.province : "")
                + (this.zip != null && this.czipity != "" ? " " + this.zip : "")
                + (this.number != null && this.number != "" ? " " + this.number : "")
                + (this.email != null && this.email != "" ? " " + this.email : "")
        };
        address.getName = function () {


            return this.name + (this.Surname != null && this.Surname != "" ? " " + this.Surname : "");


        };

        return address;
    }
    func(organizationOrderCreationDto.orderRecipient);
    func(organizationOrderCreationDto.orderSender);
    return organizationOrderCreationDto;
}